import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Injectable} from '@angular/core';
import {CamerallaAuthService} from '../authentication-services/cameralla-auth.service';
import {UserService} from '../../../modules/user/services/user.service';
import {ToastrService} from 'ngx-toastr';
import {GlobalVariables} from '../../models/cameralla-global.model';

@Injectable({
    providedIn: 'root'
})
export class PermissionAdminService implements CanActivate {
    constructor(private userService: UserService,
                private authService: CamerallaAuthService,
                private router: Router,
                private toastr: ToastrService) {
    }

    static adminConst = "administrator";
    static otherAccess = "anne@kampsport.no";

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        //const partnerPointing = route.params['partner'].toString();
        const userId = +this.authService.getLocalUserInfo()['id'];

        return new Promise<boolean>((resolveParent) => {

            this.userService.getPersonalDetails(userId).then(
                resolve => {
                    // Grant manage access for user mail: anne@kampsport.no
                    if (resolve.isKampsport && resolve.email == PermissionAdminService.otherAccess) {
                        localStorage.setItem('onlyKampsport', 'true');
                    } else {
                        if (localStorage.getItem('onlyKampsport')) {
                            localStorage.removeItem('onlyKampsport');
                        }
                    }

                    if (resolve.role == PermissionAdminService.adminConst || (resolve.isKampsport && resolve.email == PermissionAdminService.otherAccess)) {
                        resolveParent(true);
                    } else {
                        this.backToHome();
                        resolveParent(false);
                    }
                }).catch(err => {
                resolveParent(false);
            });
        })
    }

    backToHome() {
        this.toastr.error('Page not found or you are not authorized to access.', 'WARNING');
        this.router.navigate(['/']);
    }
}
